<script>
import FormModel from "@/views/Debt/Components/FormModel";

export default {
    name: "DebtForm",
    components: {FormModel},
    props: {
        addAction: Boolean,
        deleteAction: Boolean,
        updateAction: Boolean,
        viewAction: Boolean,
    },
}
</script>

<template>
    <FormModel
        :add-action="addAction"
        :update-action="updateAction"
        :delete-action="deleteAction"
        :view-action="viewAction"
        :pay_day_advance="false"
   />
</template>